import { render, staticRenderFns } from "./CoolLightBox.vue?vue&type=template&id=ed229614&"
import script from "./CoolLightBox.vue?vue&type=script&lang=js&"
export * from "./CoolLightBox.vue?vue&type=script&lang=js&"
import style0 from "./CoolLightBox.vue?vue&type=style&index=0&id=ed229614&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports